import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import Widget from '~/src/components/Widget';

import { Wrapper } from '~/src/components/Widget/styled';

export const WidgetWrapper = styled(Wrapper)<{ bgImage?: string }>`
    background-image: url(${p => p.bgImage});
    background-position: center right;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
`;

export const WidgetContent = styled(Widget.ContentBlock)<{ withPromo?: boolean }>`
    position: relative;
    padding: 24px;
    gap: ${p => p.withPromo ? '8px' : '16px'};
`;

export const WidgetName = styled(Widget.Name)`
    ${FONTS.H4};
    max-width: 80%;
    margin-bottom: 0;
    white-space: pre-wrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 90%;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        max-width: 100%;
    }
`;

export const CountPricesBlock = styled.div`
    flex-wrap: nowrap;
    gap: 16px;
`;

export const WidgetInfo = styled(Widget.Info)`
    color: ${COLORS.TextSecondary};
    display: -webkit-box;
    display: -moz-box;
    display: box;
    margin-bottom: 0;
    -webkit-box-orient: vertical;
    --moz-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

export const WidgetButton = styled(BaseButton)`
    margin-top: auto;
`;
